module.exports = __webpack_public_path__ + "ca4db41232074c1505df79f7ac476293.svg";